import { authApi } from "./index";

const FULFILLMENT_STORAGE_KEY = "amalgamate_local_fulfillments_v3";

export const getLocalFulfillments = () => {
  const data = localStorage.getItem(FULFILLMENT_STORAGE_KEY);
  return data ? JSON.parse(data) : [];
};

export const saveLocalFulfillments = (fulfillments) => {
  localStorage.setItem(FULFILLMENT_STORAGE_KEY, JSON.stringify(fulfillments));
};

export const getFulfillments = async (params = {}) => {
  try {
    const response = await authApi.get("/Fulfillments", { params });
    return response.data.data || response.data;
  } catch (error) {
    console.warn("Backend API GET /Fulfillments not reachable. Reading local storage.", error);
    let fulfillments = getLocalFulfillments();

    if (params.status) {
      fulfillments = fulfillments.filter(f => f.status === params.status.toLowerCase());
    }
    
    // Simulate pagination for local fallback
    const page = parseInt(params.page) || 1;
    const limit = parseInt(params.limit) || 10;
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    
    return fulfillments.slice(startIndex, endIndex);
  }
};

export const dispatchFulfillment = async (id, payload) => {
  try {
    const response = await authApi.patch(`/Fulfillments/${id}/dispatch`, payload);
    return response.data.data || response.data;
  } catch (error) {
    console.warn(`Backend API PATCH /Fulfillments/${id}/dispatch not reachable. Updating locally.`, error);
    const fulfillments = getLocalFulfillments();
    const index = fulfillments.findIndex(f => f.fulfillmentId === id);
    if (index === -1) {
      throw new Error("Fulfillment not found");
    }
    fulfillments[index].status = "dispatched";
    fulfillments[index].trackingNumber = payload.trackingNumber;
    fulfillments[index].carrier = payload.carrier;
    fulfillments[index].notes = payload.notes;
    fulfillments[index].updatedAt = new Date().toISOString();
    saveLocalFulfillments(fulfillments);
    return fulfillments[index];
  }
};

export const deliverFulfillment = async (id) => {
  try {
    const response = await authApi.patch(`/Fulfillments/${id}/deliver`);
    return response.data.data || response.data;
  } catch (error) {
    console.warn(`Backend API PATCH /Fulfillments/${id}/deliver not reachable. Updating locally.`, error);
    const fulfillments = getLocalFulfillments();
    const index = fulfillments.findIndex(f => f.fulfillmentId === id);
    if (index === -1) {
      throw new Error("Fulfillment not found");
    }
    fulfillments[index].status = "delivered";
    fulfillments[index].updatedAt = new Date().toISOString();
    saveLocalFulfillments(fulfillments);
    return fulfillments[index];
  }
};

// Hook/helper to auto-create local fulfillments when booking is confirmed client-side
export const triggerLocalFulfillments = (booking) => {
  try {
    const productsData = localStorage.getItem("amalgamate_local_products_v3");
    if (!productsData) return;
    const products = JSON.parse(productsData).filter(p => p.offeringId === booking.offeringId);
    if (!products.length) return;

    const fulfillments = getLocalFulfillments();
    products.forEach(product => {
      // Check if already exists to avoid duplicates
      const exists = fulfillments.some(f => f.bookingId === booking.bookingId && f.product?.productId === product.productId);
      if (exists) return;

      const newFulfillment = {
        fulfillmentId: 'ful_' + Math.random().toString(36).substr(2, 9),
        bookingId: booking.bookingId,
        customerName: booking.customerName || "Customer",
        bookingDate: booking.scheduledAt || booking.createdAt,
        quantity: 1,
        status: "pending",
        createdAt: new Date().toISOString(),
        product: product
      };
      fulfillments.unshift(newFulfillment);
    });
    saveLocalFulfillments(fulfillments);
  } catch (err) {
    console.error("Failed to trigger local fulfillments", err);
  }
};
